var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05622 24.4742L11.9499 19.4681",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5285 9.67931L21.6674 9.81236L24.7788 12.7914C25.3771 13.3643 25.3978 14.3139 24.8248 14.9122L23.4069 16.3931C22.834 16.9915 21.8844 17.0121 21.2861 16.4392L20.9249 16.0934L19.2563 17.8361C19.4286 18.4438 19.6793 19.4685 19.7773 20.5829C19.9236 22.2456 19.5274 23.512 19.0063 24.3326C18.45 25.2085 17.3609 25.1005 16.8047 24.5679L11.9708 19.9396L11.8318 19.8065L6.998 15.1781C6.44175 14.6455 6.28656 13.5622 7.13752 12.9684C7.93464 12.4122 9.18265 11.9613 10.8502 12.0353C11.9678 12.0849 13.0024 12.2908 13.617 12.4366L15.2856 10.6938L14.9245 10.348C14.3261 9.7751 14.3055 8.82558 14.8784 8.22721L16.2963 6.74631C16.8693 6.14795 17.8188 6.12732 18.4172 6.70025L21.5285 9.67931Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFilled);
export default __webpack_public_path__ + "static/media/pin-filled.6dd3ea5eb3ffc7f3b977248a450a1a61.svg";
export { ForwardRef as ReactComponent };